import { VariableType } from 'json-to-graphql-query';
import { PartnerVariables, PartnerArgs } from './queryVariables/partner';
import { ProfileVariables, ProfileArgs } from './queryVariables/profile';
import { EntityResource } from './entity.resource';
/**
 * Resource partnera
 *
 * @export
 * @class PartnerResource
 * @extends {EntityResource<Partner>}
 */
export class PartnerResource extends EntityResource {
    constructor() {
        super({ entityName: 'partner', addMutationName: 'accountPartnerRegister' });
        this.getFields = {
            id: true,
            state: true,
            name: true,
            description: true,
            descriptionShort: true,
            email: true,
            website: true,
            benefitsCount: true,
            images: true,
            mainImage: true,
            backgroundImage: true,
            woj: true,
            pow: true,
            gmi: true,
            terc: true,
            city: true,
            simc: true,
            street: true,
            homeNumber: true,
            localNumber: true,
            ulic: true,
            postalCode: true
        };
        this.listFields = {
            id: true,
            state: true,
            name: true,
            benefitsCount: true,
            mainImage: true,
            backgroundImage: true,
            images: true,
            phoneNumber: true,
            city: true,
            street: true,
            homeNumber: true,
            localNumber: true,
            postalCode: true,
            descriptionShort: true
        };
        this.addVariables = {
            login: 'String!',
            ...ProfileVariables,
            ...PartnerVariables
        };
        this.addArgs = {
            login: new VariableType('login'),
            ...ProfileArgs,
            ...PartnerArgs
        };
        this.updateVariables = { id: 'Int!', ...PartnerVariables };
        this.updateArgs = { id: new VariableType('id'), ...PartnerArgs };
    }
    /**
     * Aktualizacja partnera
     *
     * @param {number} id
     * @param {Partner} partner
     * @returns {Promise<number>}
     * @memberof PartnerResource
     */
    update(id, partner) {
        return super.update(id, {
            partner: {
                ...partner,
                id: undefined,
                benefitsCount: undefined,
                state: undefined
            }
        });
    }
    /**
     * Przełączanie statusu między `ukryty` a `aktywny`
     *
     * @param {number} id
     * @returns {Promise<number>}
     * @memberof PartnerResource
     */
    async toggleHidden(id) {
        const mutation = this.prepareOptions({
            mutation: {
                __variables: { id: 'Int!' },
                partnerToggleHidden: {
                    __args: { id: new VariableType('id') }
                }
            }
        });
        return this.mutation({
            mutation,
            variables: { id }
        }, 'partnerToggleHidden');
    }
    /**
     * Potwierdzenie konta
     *
     * @param {number} id
     * @returns {Promise<number>}
     * @memberof PartnerResource
     */
    async confirm(id) {
        const mutation = this.prepareOptions({
            mutation: {
                __variables: { id: 'Int!' },
                partnerConfirm: {
                    __args: { id: new VariableType('id') }
                }
            }
        });
        return this.mutation({
            mutation,
            variables: { id }
        }, 'partnerConfirm');
    }
    /**
     * Przypisanie wielu usług współdzielonych do Partnera
     *
     * @param {number} id
     * @param {number[]} benefitIds
     * @returns {Promise<number>}
     * @memberof PartnerResource
     */
    assignBenefits(id, benefitIds) {
        const mutation = this.prepareOptions({
            mutation: {
                __variables: { id: 'Int!', benefitIds: '[Int!]!' },
                partnerAssignBenefits: {
                    __args: {
                        id: new VariableType('id'),
                        benefitIds: new VariableType('benefitIds')
                    }
                }
            }
        });
        return this.mutation({ mutation, variables: { id, benefitIds } }, 'partnerAssignBenefits');
    }
}
export const partnerResource = new PartnerResource();
//# sourceMappingURL=partner.resource.js.map